// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"8ea13d92","453":"b4dd9834"}[chunkId] + ".chunk.js";
};